import React, { useState, useRef, useEffect } from 'react'
import { Icon, Input, Spin, Modal, Button, message, Select, Progress } from "antd"
import { ExclamationCircleOutlined, CheckCircleFill } from '@ant-design/icons'
import { PERIODS } from '../helper/ListPeriods'
import { listBatchesV4, markFinishPeriods } from '../../../services/api/3dApi'
import { NavLink } from 'react-router-dom'
import { getUserList } from '../../../services/api/UserService'
import ScannedBatchTable from './ScannedBatchTable'

function BatchesMarkPeriodsPage() {
    const _input = useRef()
    const [loading, setLoading] = useState(false)
    const [valueInput, setValueInput] = useState('')
    const [errorInput, setErrorInput] = useState('')
    const [batchesId, setBatchesId] = useState('')
    const [listUser, setListUser] = useState([])
    const [period, setPeriod] = useState('')
    const [implementer, setImplementer] = useState('')
    const [listBatches, setListBatches] = useState([])

    const { Option } = Select

    const checkPeriod= (value) => {
        const stages = !!value && !!value.length && value.map(i => i.period_name)
        return stages.includes(period) ? true : false
    }

    const _onSubmit = async (e) => {
        e.preventDefault()
        setLoading(true)

        const checkValue = /^\w+-\d/.test(valueInput)
        const valueSplit = valueInput.includes(',') && Array.from(new Set(valueInput.trim().replace(' ', ',').split(',').filter(i => i !== '')))

        if ((!checkValue && !valueSplit.length ) || !valueInput.trim()) {
            setErrorInput('Mã lô sai định dạng.')
            setLoading(false)
        }

        if (checkValue && valueInput.trim()) {
            const payload = {}
            if (valueInput.includes(',')) { payload.name = { '$in': valueSplit } }
            else { payload.name = valueInput }

            try {
                const { data } = await listBatchesV4(payload)
                const { data: res } = Object.assign({}, data)
                const { batches } = res

                if (!batches.length > 0) return Modal.error({
                    title: 'Lỗi',
                    content: 'Không tìm thấy tên lô',
                    onOk: _resetScanInput(),
                    okText: 'Đóng'
                })
                const newList = []
                batches.forEach(batch => {
                    const { _id, status, name, product_types, finish_periods } = batch

                    setBatchesId(_id)
                    if (!!product_types && product_types.length > 1) return message.error(`Lô ${name} có nhiều SKU!`)
                    if (!!finish_periods && !!finish_periods.length) {
                        if (checkPeriod(finish_periods)) {

                            return message.error(`Lô ${name} đã được đánh dấu hoàn thiện ở công đoạn ${PERIODS[period]}!`)
                        }
                    }
                    if (!!listBatches && !!listBatches.length && listBatches.map(i => i.id).includes(_id)) {
                        return setValueInput('')
                    }
                    if (!['sewing', 'completed'].includes(status)) return message.error(`Lô ${name} đang ở trạng thái ${status}, không thể đánh dấu!`)
                    newList.push({ id: _id, name: name, SKU: product_types })

                })
                setListBatches([...newList, ...listBatches])
                setValueInput('')

            } catch (error) {
                setErrorInput(error)
            } finally {
                setLoading(false)
            }
        }
    }

    const _resetScanInput = () => {
        setValueInput('')
        _input.current.focus()
    }

    const _handleChangeScan = e => {
        setValueInput(e.target.value)
        setErrorInput('')
    }

    const handleMark = async (e) => {
        e.preventDefault()
        setLoading(true)
        setErrorInput('')
        const payload = {}
        if (!!period) payload.period = period
        if (!!implementer) payload.marker = implementer
        if (!!listBatches && !!listBatches.length) payload.batchNames = listBatches.map(i => i.name)
        try {
            const { data: response } = await markFinishPeriods(payload)
            const { error, success, data } = Object.assign({}, response)
            const { failedBatches, updatedBatches } = data

            if (!success) return message.error(error)
            return Modal.info({
                title: 'Đánh dấu lô hoàn thiện',
                icon: false,
                style: { minWidth: '45%' },
                content: (
                    <div className="ListProcessing">
                        <ul>
                            {
                                !!listBatches && listBatches.length > 0 && listBatches.map(item => (
                                    <li key={item._id}>
                                        <span className='mr-3 font-weight-bold'>{item.name}</span>
                                        {
                                            !!failedBatches.length && !!failedBatches.filter(i => i.name === item.name).length &&
                                            <span className="Error text-danger">{failedBatches.filter(i => i.name === item.name).map(i=>i.message)[0]}</span>
                                        }
                                        {
                                            !!updatedBatches.length && !!updatedBatches.filter(i => i.name === item.name).length &&
                                            <span className="Success text-success">Đánh dấu lô hoàn thiện [{PERIODS[period]}]</span>
                                        }
                                        <Progress
                                            percent={100}
                                            size="small"
                                            status={`${(!!updatedBatches.filter(i => i.name === item.name).length) ? 'success' :
                                                ((!!failedBatches.filter(i => i.name === item.name).length) ? 'exception' : 'active')
                                            }`}
                                        />
                                    </li>))
                            }
                        </ul>
                    </div>
                ),
                onOk: () => {
                    _resetScanInput()
                    setListBatches([])
                },
                okText: 'Đóng'
            })

        } catch (error) {
            message.error(error)
        } finally {
            setLoading(false)
        }

    }

    const fetchUser = async () => {
        try {
            const { data, message, success } = await getUserList({ page: 1, limit: 10000, is_active: true})
            if (!success) {
                console.log(message)
            } else {
                setListUser(data.users)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleChangePeriod = (value) => {
        setListBatches([])
        setPeriod(value)
    }
    const handleChangeImplementer = (value) => {
        setImplementer(value)
    }

    const handleDeleteBatch = (batchId) => {
        const newList = listBatches.filter(i => i.id !== batchId)
        setListBatches(newList)
    }

    const checkRoles = (roles) => {
        const Roles = !!roles && !!roles.length && roles.map((i, index) => i.name)
        if (!!Roles && Roles.includes('FFM') && !Roles.includes('Super Admin')) {
            return false
        } else {
            return true
        }
    }

    const getOptionsByObject = (objectValue) => {
        const array = []
        for (const key in objectValue) {
            if (objectValue.hasOwnProperty(key)) {
                const value = objectValue[key]
                const option = <Option key={key} value={key}>
                    {value}
                </Option>
                array.push(option)
            }
        }
        return array
    }

    useEffect(() => {
        fetchUser()
    }, [])

    useEffect(() => {
        if (!!period && !!implementer) {
            _input.current.focus()
        }
    }, [period, implementer])

    const userOptions = !!listUser.length && listUser.filter((i) => (
        !!checkRoles(i.roles)
    )).map((i, index) => ({ name: i.username, value: i.username }))

    return (
        <div className='BatchesMarkPeriodsPage py-5'>
            <div className="col-12 mx-auto px-5">
                <div className="d-flex align-items-baseline justify-content-between">
                    <h1 className="PageTitle">Đánh dấu lô hoàn thiện</h1>
                    <label className="border rounded cursor-pointer font-weight-bold py-2 px-4 bg-white h6">
                        <NavLink exact to='/list-periods' className='nav-link p-0'>
                            Thống kê hoàn thiện
                        </NavLink>
                    </label>
                </div>
                <div className="site-layout-background pb-4">
                    <Spin spinning={loading} tip='Đang kiểm tra...'>
                        <div className="d-flex align-items-start mt-4 justify-content-between">
                            <div className="contentLeft">
                                <div className="markInfo d-flex flex-column">
                                    <h3 className='mb-5'>THÔNG TIN ĐÁNH DẤU</h3>
                                    <div className="period d-flex align-items-center mb-5 justify-content-between">
                                        <label className='mr-3 mx-0'>Công đoạn</label>
                                        <Select
                                            size='large'
                                            showSearch
                                            style={{ minWidth: '300px' }}
                                            placeholder='-- Chọn công đoạn --'
                                            allowClear
                                            value={period || []}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            onChange={handleChangePeriod}
                                        >
                                            {!!Object.keys(PERIODS).length &&
                                                getOptionsByObject(PERIODS)
                                            }
                                        </Select>
                                    </div>
                                    <div className="performer d-flex align-items-center mb-5 justify-content-between">
                                        <label className='mr-3 mx-0'>Người thực hiện</label>
                                        <Select
                                            size='large'
                                            showSearch
                                            style={{ minWidth: '300px' }}
                                            placeholder='-- Chọn người thực hiện --'
                                            allowClear
                                            value={implementer || []}
                                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            onChange={handleChangeImplementer}
                                        >
                                            {!!userOptions && !!userOptions.length &&
                                                userOptions.map((item, index) =>
                                                    item.name.includes("_thuadinh") ?
                                                    <Option key={index} value={item.value}>
                                                        {item.name}
                                                    </Option>: null
                                                )
                                            }
                                        </Select>
                                    </div>
                                </div>
                                {
                                    (!loading) && !!listBatches.length &&
                                    <Button
                                        type='primary'
                                        className='mt-3 float-right'
                                        size='large'
                                        onClick={handleMark}
                                        disabled={!period || !implementer}
                                    >
                                        Xác nhận
                                    </Button>
                                }
                            </div>
                            <div className="contentRight">
                                <div className="position-relative px-0">
                                    <form onSubmit={_onSubmit} className="formQC">
                                        <Input
                                            value={valueInput.toUpperCase()}
                                            style={{ fontSize: 40, height: "auto" }}
                                            ref={_input}
                                            autoFocus={true}
                                            placeholder='Nhập lô cần đánh dấu'
                                            disabled={!period || !implementer}
                                            onChange={_handleChangeScan}
                                        />

                                        {
                                            !!valueInput &&
                                            <Icon
                                                type='close-circle'
                                                className="position-absolute cursor-pointer text-dark IconInput"
                                                onClick={_resetScanInput}
                                            />
                                        }

                                        {
                                            loading &&
                                            <Icon type="sync" spin className="position-absolute IconInput" />
                                        }
                                    </form>
                                    {errorInput && <div className="text-danger mt-3">{errorInput}</div>}
                                </div>
                                {!!listBatches && !!listBatches.length &&
                                    <div className="listScannedBatch">
                                        <ScannedBatchTable listBatches={listBatches} handleDeleteBatch={handleDeleteBatch} />
                                    </div>
                                }
                            </div>
                        </div>
                    </Spin>
                </div>
            </div>
        </div>
    )
}

export default BatchesMarkPeriodsPage